import React from "react";

export const FilterPanel = ({
    title = "",
    filtersConfig = [],
    filters = {},
    setFilters
}) => {

    // 🔥 Toggle tipo radio (solo uno activo)
    const toggle = (groupKey, value) => {
        setFilters(prev => ({
            ...prev,
            [groupKey]: prev[groupKey] === value ? null : value
        }));
    };

    return (
        <div className="filtro-container-reutilizable">

            {/* HEADER */}
            {title !== "" && (
                <div className="filtro-header">
                    <div className="filtro-header-titulo">
                        {title}
                    </div>
                </div>
            )}

            {/* GRUPOS */}
            {filtersConfig.map((group) => {
                const selectedValue = filters[group.key];

                return (
                    <div key={group.key} className="filtros-seccion">

                        {/* TITULO */}
                        <h4 className="filtros-titulo">
                            {group.icon && <span style={{ marginRight: 6 }}>{group.icon}</span>}
                            {group.label}
                        </h4>

                        {/* BOTONES */}
                        <div className="filtros-botones">
                            {group.options.map((opt) => {
                                const isActive = selectedValue === opt.value;

                                return (
                                    <button
                                        key={opt.value}
                                        type="button"
                                        onClick={() => toggle(group.key, opt.value)}
                                        className={`filtro-boton ${isActive ? "activo" : ""}`}
                                    >
                                        {/* ICONO */}
                                        {/* {opt.icon && (
                                            <span className="filtro-boton-icono">
                                                {opt.icon}
                                            </span>
                                        )} */}

                                        {opt.label}
                                        {/* {isActive && <span className="filtro-boton-check">✓</span>} */}
                                    </button>
                                );
                            })}
                        </div>

                    </div>
                );
            })}
        </div>
    );
};